/* @flow */

import * as selectors from './assignables-selectors';

export const Assignables = {
    ...selectors,
};
